export const cqiircaTrainingData = [
  //quality
  {
    mainHeading: "CQI & IRCA Training Details",
    selection: "QMS - ISO 9001:2015 Lead Auditor",
    mainTitle:
      "CQI & IRCA Certified QUALITY MANAGEMENT SYSTEMS Auditor / Lead Auditor – ISO 9001:2015 Training Course (CQI & IRCA Ref 17980)",

    pdf: "https://drive.google.com/file/d/1jLaxfNxrISzRijS5y7qAX7mBEEDuXFQF/view?usp=drivesdk  ",
  },
  {
    mainHeading: "CQI & IRCA Training Details",
    selection: "QMS - ISO 9001:2015 Transition Training",
    mainTitle:
      "CQI & IRCA Certified ISO 9001ۉ2015 Auditor Transition (QMS)Training Course (Course ID: 17901)",

    pdf: "https://drive.google.com/file/d/1Dtsiwx9EgXhVVas1rcmXDpaNPe6Y7E_R/view?usp=drivesdk ",
  },
  {
    mainHeading: "CQI & IRCA Training Details",
    selection: "QMS - ISO 9001:2015 Internal Auditor",
    mainTitle:
      "CQI and IRCA Certified ISO 9001ۉ2015 Internal Auditor (QMS)Training Course (Course ID: 1661)",

    pdf: "https://drive.google.com/file/d/13ZA4OtSHbuTT388cWROtyk99fqizvmxy/view?usp=drivesdk ",
  },

  //environment///////////////////////////////////////////////////////////
  {
    pdf: "https://drive.google.com/file/d/1UKarZxnzLKRsW_b92jxrs3BxKR1Wg-gB/view?usp=sharing",
    FileName: "EMS_Lead_Auditor_Training.pdf",

    mainHeading: "CQI & IRCA Training Details",
    selection: "EMS - ISO 14001:2026 Lead Auditor",
    mainTitle:
      "CQI & IRCA Certified EMS Lead Auditor –  ISO 14001:2026 Lead Auditor (Environment Management Systems) Training Course (CQI & IRCA Ref: 1709)",
  },
  {
    pdf: "https://drive.google.com/file/d/1mcFP7BY7UYCtYF38LQnGBscrWtvPO8JA/view?usp=drivesdk ",
    FileName: "EMS_Internal_Auditor_Training.pdf",

    mainHeading: "CQI & IRCA Training Details",
    selection: "EMS - ISO 14001:2015 Internal Auditor",
    mainTitle:
      "ISO 14001: 2015 Internal Auditor (Environment Management Systems) Training Course (CQI IRCA Ref. No: 1657)",
  },
  {
    pdf: "https://drive.google.com/file/d/1f7dWvO2JlEYTIf64a8QiFgy9J55Zb8sN/view?usp=drivesdk ",
    FileName: "EMS_Auditor_Transition_Training.pdf",
    mainHeading: "CQI & IRCA Training Details",
    selection: "EMS - ISO 14001:2015 Auditor Transition",
    mainTitle:
      "ISO 14001:2015 Auditor Transition Training Course (CQI & IRCA Ref: 17900 & 17933)",
  },
  {
    mainHeading: "CQI & IRCA Training Details",
    selection: "EMS - ISO 14001:2015 Auditor Conversion",
    mainTitle:
      "CQI & IRCA Certified EMS (14001:2015) Auditor Conversion Training Course (CQI &IRCA Ref: 1634)",
  },

  //Occupational Health & Safety Management Systems///////////////////////////////
  {
    pdf: "https://drive.google.com/file/d/1kizCPw2WJ4Xg3ayaGdrmkXjZkv2WZgP1/view?usp=drivesdk ",

    mainHeading: "CQI & IRCA Training Details",
    selection: "OHSMS - ISO 45001:2018 Lead Auditor",
    mainTitle:
      "CQI & IRCA OHSMS Lead Auditor –  ISO 45001:2018 Lead Auditor (Occupational Health & Safety  Management Systems) Training Course (CQI & IRCA Ref: 1878)",
  },

  {
    pdf: "https://drive.google.com/file/d/1fmSCiZRHqTDEeFXQcM15_jo3vzx-kYur/view?usp=drivesdk ",
    mainHeading: "CQI & IRCA Training Details",
    selection: "OHSMS - ISO 45001:2018 Internal Auditor",
    mainTitle:
      "Internal Auditor Training Course OHSMS ISO 45001:2018 (course ID:2430)",
  },
  {
    pdf: "https://drive.google.com/file/d/1XEyo684EeJMOYoDpJZmsIhiDd5Qv8nsO/view?usp=drivesdk ",
    FileName: "OHSMS_Lead_Auditor_Training.pdf",

    mainHeading: "CQI & IRCA Training Details",
    selection: "OHSMS - ISO 45001:2018 Auditor Migration",
  },

  // Information Securiy ///////////////////////////////////////////////
  {
    pdf: "https://drive.google.com/file/d/1XkYerCsuHNKNTP09qERncOUxymtl1LWm/view?usp=drive_link",
    mainHeading: "CQI & IRCA Training Details",
    selection: "ISMS - ISO 27001:2022 Lead Auditor",
    mainTitle:
      "CQI & IRCA Certified ISMS Lead Auditor – ISO 27001:2022 Lead Auditor (Information Security Management Systems) Training Course (CQI & IRCA Ref: 2557)",
  },
  {
    pdf: "https://drive.google.com/file/d/1QYQ4c0jEu-MG3Bppkhvk9HTfPQePfi3M/view?usp=drive_link",
    mainHeading: "CQI & IRCA Training Details",
    selection: "ISMS - ISO 27001:2022 Internal Auditor",
    mainTitle:
      "CQI & IRCA Certified ISMS Internal Auditor – ISO 27001:2022 Internal Auditor (Information Security Management Systems) Training Course (CQI & IRCA Ref: 2558)",
  },

  //food security management ////////////////////////////////////////////////////
  {
    pdf: "https://drive.google.com/file/d/1HvLsGtb17Fk1L9I_7xi0ZU1lpzGiyhkR/view?usp=drive_link",
    mainHeading: "CQI & IRCA Training Details",
    selection: "FSMS - ISO 22000:2018 Lead Auditor",
    mainTitle:
      "CQI & IRCA Certified FSMS Auditor / Lead Auditor – ISO 22000:2005 Training Course (CQI & IRCA Ref 18205)",
  },
  {
    pdf: "https://drive.google.com/file/d/1pzs_AgBr6m7ZkeqskOuRg6sqYY3msKcq/view?usp=drive_link",
    mainHeading: "CQI & IRCA Training Details",
    selection: "FSMS - ISO 22000:2018 Internal Auditor",
    mainTitle:
      "CQI & IRCA Certified FSMS Auditor / Internal Auditor – ISO 22000:2005 Training Course ( CQI & IRCA Ref No: 1844)",
  },
  {
    pdf: "https://drive.google.com/file/d/1OIQFO0tVLHHXe9GCQhZuu_3KH7j4AIwe/view?usp=drive_link",
    mainHeading: "CQI & IRCA Training Details",
    selection: "FSMS - ISO 22000:2018 Auditor Transition",
    mainTitle:
      "ISO 22000:2018 Auditor Transition Training Course (CQI & IRCA Ref: 17900 & 2062)",
  },

//FSSC///////////////////////////
  {
    pdf: "https://drive.google.com/file/d/18JpSLpbpez8xakzxm6otBpIJ2zumzozt/view?usp=sharing",
    mainHeading: "CQI & IRCA Training Details",
    selection: "FSSC - 22000 Lead Auditor",
    mainTitle:
      "CQI and IRCA Certified FSSC 22000 Version 6 Lead Auditor Training Course (Course ID: 2686)",
  },

  //energy
  {
    pdf: "https://drive.google.com/file/d/1fVdLeGS4yLxZ6SD2Io1MpOeGMQ9EEkHn/view?usp=sharing",
    mainHeading: "CQI & IRCA Training Details",
    selection: "EnMS - ISO 50001:2018 Lead Auditor",
    mainTitle:
      "CQI and IRCA Certified ISO 50001:2018 Lead Auditor (EnMS) Training Course (Course ID: 2441)",
  },
];

export const examplarGlobalTrainingData = [
  //quality
  {
    pdf:"https://drive.google.com/file/d/1VzjqEuoV-B5as4p58W6zYKRZJfKUluq_/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "QMS - ISO 9001:2015 Lead Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified QMS Auditor / Lead Auditor - ISO 9001:2015 Training Course",
  },
  {
    pdf:"https://drive.google.com/file/d/1tBMKoYFCHfctbcyFLCXvtqVw7wQRmYMX/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "QMS - ISO 9001:2015 Internal Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified QMS Auditor / Internal Auditor - ISO 9001:2015 Training Course",
  },
  {
    pdf:"https://drive.google.com/file/d/1ydjqTpnuDqB81DcPjNL9OVaOqwYGS4AF/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "QMS - ISO 9001:2015 Transition Training",
    mainTitle:"EXEMPLAR GLOBAL Certified QMS Auditor Transition - ISO 9001:2015 Training Course",   
  },

  //environment
  {
    pdf:"https://drive.google.com/file/d/1gBGHf2lGEg22fIQFegs6rDfaZvqJC2-a/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "EMS - ISO 14001:2026 Lead Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified EMS Auditor / Lead Auditor - ISO 14001:2026 Training Course",
  },
  {
    pdf:"https://drive.google.com/file/d/1gD3_J9OVbhhPkTBmxEGBQAn-zUR_t1hC/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "EMS - ISO 14001:2026 Internal Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified EMS Auditor / Internal Auditor - ISO 14001:2026 Training Course",
  },
  {
    pdf:"https://drive.google.com/file/d/19rY_DZBGAQ87ZqeK3supHvBHziwN7lnA/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "EMS - ISO 14001:2026 Auditor Transition",
    mainTitle: "EXEMPLAR GLOBAL Certified EMS Auditor / Transition Auditor - ISO 14001:2026 Training Course",
  },

  //QHSMS/////////////////////////

  {
    pdf:"https://drive.google.com/file/d/1-14MiVjp-rTPSiN9LGfc0JWCLBTVJTKU/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "OHSMS - ISO 45001:2018 Lead Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified OHSMS Auditor / Lead Auditor - ISO 45001:2018 Training Course",
  },

  {
    pdf:"https://drive.google.com/file/d/1QU7sKxDCkNy5c2Ul7m5Rzc9RxUm71Rcn/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "OHSMS - ISO 45001:2018 Auditor Transition",
    mainTitle:
      "EXEMPLAR GLOBAL Certified OHSMS Auditor / Transition Auditor - ISO 45001:2018 Training Course",
  },
  {
    pdf:"https://drive.google.com/file/d/1G8a8chMfVexRe4gfMMCkRIZqW1h5L35i/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "OHSMS - ISO 45001:2018 Internal Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified OHSMS Auditor / Internal Auditor - ISO 45001:2018 Training Course",
  },

  // Information Securiy
  {
    pdf:"https://drive.google.com/file/d/10Z4xajDcixLj17ZAdsc57vCbX82bREq9/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "ISMS - ISO 27001:2022 Lead Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified ISMS Auditor / Lead Auditor - ISO 27001:2022 Training Course",
  },
  {
    pdf:"https://drive.google.com/file/d/10Z4xajDcixLj17ZAdsc57vCbX82bREq9/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "ISMS - ISO 27001:2022 Internal Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified ISMS Auditor / Internal Auditor - ISO 27001:2022 Training Course",
  },

  //food security management
  {
    pdf:"https://drive.google.com/file/d/1jRap0f5UMP2OvFE7t5gOSszm8k0qwfyb/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "FSMS - ISO 22000:2018 Lead Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified FSMS Auditor / Lead Auditor - ISO 22000:2018 Training Course",
  },

  {
    pdf:"https://drive.google.com/file/d/1bWpg2WQiGGKe7RLHU6pIWcQ2j-i9WizR/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "FSMS - ISO 22000:2018 Auditor Transition",
    mainTitle:
      "EXEMPLAR GLOBAL Certified FSMS Auditor / Transition Auditor - ISO 22000:2018 Training Course",
  },
  {
    pdf:"https://drive.google.com/file/d/1A9WVBoxr06OjO-bM1Kj9yz184E9xC7J8/view?usp=drive_link",
    mainHeading: "Examplar Global Training Details",
    selection: "FSMS - ISO 22000:2018 Internal Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified FSMS Auditor / Internal Auditor - ISO 22000:2018 Training Course",
  },

  //FSSC///////////////////////////
  {
    pdf: "https://drive.google.com/file/d/1iPisb170AVgz4R6XsCh2OCcxGSIXx3kZ/view?usp=drive_link",
    mainHeading: "CQI & IRCA Training Details",
    selection: "FSSC - ISO 22000 Lead Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified FSSC Auditor / Lead Auditor - FSSC 22000 Ver 6.0 Training Course",
  },

  //energy
  {
    pdf: "https://drive.google.com/file/d/1X08-uzHhdPKLEVHwXtLOpnM9YKXiRDDP/view?usp=sharing",
    mainHeading: "CQI & IRCA Training Details",
    selection: "EnMS - ISO 50001:2018 Lead Auditor",
    mainTitle:
      "EXEMPLAR GLOBAL Certified EnMS Auditor / Lead Auditor - ISO 50001ۉ2018 Training Course",
  },
  //ghg
  {
    pdf: "https://drive.google.com/file/d/13BWeqq4pYWBnje9-1fjb_RDZeBbl1gDU/view?usp=sharing",
    mainHeading: "Examplar Global Training Details",
    selection: "GHG - ISO 14064:2018 Lead Verifier",
    mainTitle:
      "EXEMPLAR GLOBAL Certified ISO 14064 Series Greenhouse Gas Accounting (GHG) Lead Verifier/Lead Validator Training Course",
  },
 
];

export const pecbData = [
  {
    id: 1,
    name: "Information Security Management Systems Based on ISO/IEC 27001",
  },
  {
    id: 2,
    name: "Information Security Controls — Best Practices Based on ISO/IEC 27002",
  },
  {
    id: 3,
    name: "Information Security Risk Management Based on ISO/IEC 27005",
  },
  { id: 4, name: "Information Security Risk Management Based on EBIOS" },
  {
    id: 5,
    name: "Information Security Incident Management Based on ISO/IEC 27035",
  },
  { id: 6, name: "Human Resources Security" },
  { id: 7, name: "Cyber Security Based on ISO/IEC 27032" },
  { id: 8, name: "SCADA Security" },
  { id: 9, name: "Certified Lead Ethical Hacker" },
  { id: 10, name: "Lead Cloud Security Manager" },
  { id: 11, name: "ISO/IEC 27033 Lead Network Security Manager" },
  { id: 12, name: "Penetration Testing" },
  { id: 13, name: "Cyber Security Essentials" },
  { id: 14, name: "Cyber Security Maturity Model Certification (CMMC)" },
  { id: 15, name: "Business Continuity Management Systems Based on ISO 22301" },
  { id: 16, name: "Disaster Recovery" },
  { id: 17, name: "Organizational Resilience Based on ISO 22316" },
  { id: 18, name: "Business Impact Analysis Based on ISO/TS 22317" },
  { id: 19, name: "Anti-Bribery Management Systems Based on ISO 37001" },
  { id: 20, name: "IT Corporate Governance Based on ISO/IEC 38500" },
  { id: 21, name: "Compliance Management Systems Based on ISO 37301" },
  { id: 22, name: "GDPR — Certified Data Protection Officer" },
  {
    id: 23,
    name: "Privacy Information Management Systems Based On ISO/IEC 27701",
  },
  { id: 24, name: "Certified Digital Transformation Officer (CDTO)" },
  { id: 25, name: "Digitalization and Electronic Archiving (DEA)" },
  { id: 26, name: "Artificial Intelligence" },
  { id: 27, name: "Big Data" },
  { id: 28, name: "Block chain" },
  { id: 29, name: "CLOUD COMPUTING" },
  { id: 30, name: "INTERNET OF THINGS (IoT)" },
  { id: 31, name: "Six Sigma Belts" },
  {
    id: 32,
    name: "Quality Management Systems for Medical Devices Based on ISO 13485",
  },
  { id: 33, name: "Laboratory Management Based on ISO/IEC 17025" },
  { id: 34, name: "IT Service Management System based on ISO/IEC 20000" },
  {
    id: 35,
    name: "Management Systems for Educational Organizations Based on ISO 21001",
  },
  { id: 36, name: "Management Systems for Records Based on ISO 30301" },
  { id: 37, name: "Project Management Based on ISO 21500" },
  { id: 38, name: "Asset Management Systems Based on ISO 55001" },
  {
    id: 39,
    name: "Supply Chain Security Management Systems Based on ISO 28000",
  },
  {
    id: 40,
    name: "Occupational Health and Safety Management Systems Based on ISO 45001",
  },
  { id: 41, name: "Food Safety Management Systems Based on ISO 22000" },
  { id: 42, name: "Security Operations Management Systems Based on ISO 18788" },
  { id: 43, name: "Social Management Systems Based on ISO 26000" },
  { id: 44, name: "Environmental Management Systems Based on ISO 14001" },
  { id: 45, name: "Energy Management Systems Based on ISO 50001" },
  { id: 46, name: "Sustainable Development in Communities Based on ISO 37101" },
  { id: 47, name: "Sustainable Procurement Based on ISO 20400" },
];

export const healthSafetyData = [
  {
    id: 1,
    name: "EOSH UK Level 2 – Award in Workplace Health & Safety",
    duration: 3,
  },
  {
    id: 2,
    name: "EOSH UK Level 3 – Award in Workplace Health & Safety",
    duration: 7,
  },
  {
    id: 3,
    name: "EOSH UK Level 4 – Award in Workplace Health & Safety",
    duration: 10,
  },
  { id: 4, name: "EOSH UK Level 3 – Process Safety Management", duration: 4 },
  {
    id: 5,
    name: "EOSH UK Award in workplace Health & Safety for supervision",
    duration: 4,
  },
  {
    id: 6,
    name: "EOSH UK Award in HSE Manager (Health, Safety & Environment)",
    duration: 6,
  },
  {
    id: 7,
    name: "EOSH UK Award in HSE Inspector (Health, Safety & Environment)",
    duration: 4,
  },
  { id: 8, name: "EOSH UK Award in Health & Safety for Workers", duration: 8 },
  { id: 9, name: "EOSH UK – Train the Trainer-HSE", duration: 8 },
];
export const fireData = [
  { id: 1, name: "EOSH UK Level 2 Award in Basic Fire Safety", duration: 3 },
  {
    id: 2,
    name: "EOSH UK Level 3 Award in Fire Safety Management",
    duration: 7,
  },
  {
    id: 3,
    name: "EOSH UK Level 2 Award in Fire & Industrial Safety",
    duration: 3,
  },
  {
    id: 4,
    name: "EOSH UK Level 3 Award in Fire & Industrial Safety ",
    duration: 7,
  },
  { id: 5, name: "EOSH UK Award in Fire Safety for Managers ", duration: 4 },
  {
    id: 6,
    name: "EOSH UK Award in Fire Safety & Hazard Management ",
    duration: 4,
  },
  {
    id: 7,
    name: "EOSH UK Award in Firefighting & Fire Extinguisher Safety",
    duration: 4,
  },
  {
    id: 8,
    name: "EOSH UK Award in Train The Trainer- Fire Safety",
    duration: 8,
  },
];

export const environmentData = [
  {
    id: 1,
    name: "EOSH UK Level 2- Award in Environmental Principles",
    duration: 3,
  },
  {
    id: 2,
    name: "EOSH UK Level 3- Award in Environmental Management",
    duration: 7,
  },
  {
    id: 3,
    name: "EOSH UK Level 4- Award in Environmental Management & Legal Compliance",
    duration: 10,
  },
  {
    id: 4,
    name: "EOSH UK – Award in Environmental and Social Action Plan (ESAP) for Managers  ",
    duration: 4,
  },
  {
    id: 5,
    name: "EOSH UK – Award in EHS Guidelines-Environment, Health & Safety  ",
    duration: 4,
  },
  {
    id: 6,
    name: "EOSH UK – Award in Environmental Management System Audit Techniques & Best Practices ",
    duration: 4,
  },
  {
    id: 7,
    name: "EOSH UK – Award in Environmental Quality Monitoring & Analysis ",
    duration: 4,
  },
];

export const environmentSustainabilityData = [
  {
    id: 1,
    name: "EOSH UK Level 2- Award in Introduction to Environmental Sustainability",
    duration: 3,
  },
  {
    id: 2,
    name: "EOSH UK Level 3- Award in Environmental Sustainability",
    duration: 7,
  },
  {
    id: 3,
    name: "EOSH UK- Award in Sustainability in Building Structure. ",
    duration: 4,
  },
  {
    id: 4,
    name: "EOSH UK- Award in Environmental Sustainability Skills for Managers ",
    duration: 4,
  },
  {
    id: 5,
    name: "EOSH UK- Award in Environmental Sustainability Skills for Workforce ",
    duration: 4,
  },
  {
    id: 6,
    name: "EOSH UK- Award in Sustainability in Waste Water Management ",
    duration: 4,
  },
  {
    id: 7,
    name: "EOSH UK- Award in Environmental Sustainable Monitoring at Workplace",
    duration: 4,
  },
  {
    id: 8,
    name: "EOSH UK- Award in Life Safety & Environmental Protection",
    duration: 4,
  },
];

export const liftingRiggingData = [
  {
    id: 1,
    name: "EOSH UK Level 2 – Award in Lifting & Rigging Safety",
    duration: 3,
  },
  {
    id: 2,
    name: "EOSH UK Level 3 – Award in Lifting & Rigging Safety",
    duration: 7,
  },
  {
    id: 3,
    name: "EOSH UK Level 2- Award in Basic Rigger and Signalman ",
    duration: 3,
  },
  {
    id: 4,
    name: "EOSH UK Level 3- Award in Principles of Rigger and Signalman  ",
    duration: 7,
  },
  {
    id: 5,
    name: "EOSH UK Level 4- Award in Advanced Rigger and Signalman ",
    duration: 10,
  },
  { id: 6, name: "EOSH UK- Award in Lifting Supervisor ", duration: 4 },
  {
    id: 7,
    name: "EOSH UK – Award in Lifting & Rigging Supervisor",
    duration: 4,
  },
  {
    id: 8,
    name: "EOSH UK Award in Train The Trainer – Lifting & Rigging",
    duration: 8,
  },
  { id: 9, name: "EOSH UK Award in Equipment Safety Inspection", duration: 4 },
  { id: 10, name: "EOSH UK Award in Flagman Safety Training", duration: 4 },
];
export const scaffolfingData = [
  {
    id: 1,
    name: "EOSH UK – Award in Scaffolding Safety Awareness",
    duration: 4,
  },
  {
    id: 2,
    name: "EOSH UK Level 2- Award in Basic Scaffolding Safety",
    duration: 3,
  },
  {
    id: 3,
    name: "EOSH UK Level 3 – Award in Scaffolding Safety ",
    duration: 7,
  },
  { id: 4, name: "EOSH UK – Award in Scaffolding Inspector  ", duration: 4 },
  { id: 5, name: "EOSH UK – Award in Scaffolding Erector ", duration: 4 },
  { id: 6, name: "EOSH UK – Award in Scaffolding Supervisor ", duration: 4 },
  { id: 7, name: "EOSH UK Award in Scaffolding for Manager", duration: 4 },
  {
    id: 8,
    name: "EOSH UK Award in Safe Scaffolding Erection, Dismantling & Modification",
    duration: 4,
  },
  {
    id: 9,
    name: "EOSH UK Award in Train the Trainer- Scaffolding",
    duration: 8,
  },
];
export const firstAidData = [
  {
    id: 1,
    name: "EOSH UK Level 2 Award in Basic Life Support and Safe Use of an Automated External Defibrillator (RQF) ",
    duration: 4,
  },
  {
    id: 2,
    name: "EOSH UK Level 2 Award in Emergency First Aid at work",
    duration: 3,
  },
  { id: 3, name: "EOSH UK Level 3 Award in First Aid at work ", duration: 7 },
  { id: 4, name: "EOSH UK – Award in First AID & AED   ", duration: 4 },
  { id: 5, name: "EOSH UK- Award in CPR & First Aid  ", duration: 4 },
];


export const eoshPdf=[
  {
    healthSafety:"https://drive.google.com/file/d/1CpyoSSo11TMaoAKEhpWWfbuUDcyjAj3_/view?usp=drive_link",
    fire:"https://drive.google.com/file/d/1fBjohcgvnwQIguXBwvWUYsiHCVhFG6gN/view?usp=drive_link",
    environment:"https://drive.google.com/file/d/1LdV0efRf7DTj_rNq6lYIs6tMs4vi3LnW/view?usp=drive_link",
    environmentSustainability:"https://drive.google.com/file/d/1Bj15UExvIZH-yvTDed1CnrjUqunqsINY/view?usp=drive_link",
    firstAid:"https://drive.google.com/file/d/1vMt4PYSTmIf3EJt1aDmShXyrRAYQzE0M/view?usp=drive_link",
    liftingRigging:"https://drive.google.com/file/d/1-9G3M9B-ZqtPu6SjhItXYdfqx2Bkm9qe/view?usp=drive_link",
    scaffolfing:"https://drive.google.com/file/d/1ATVxn1GtFGnnkHbiArncK9ix5cpoaQFB/view?usp=drive_link",
  }
]
